import React from 'react';
import { useIntl } from 'react-intl';
import { CollapsableBlock } from 'components/collapsable-block';
import { ReceiptUserResponse } from '../receipt-user-response';

interface ReceiptAdditionalInformationProps {
  formResponses: Array<FormResponse>;
  /*
   * RES-1367: drops the block's top border and 28px lead-in, both of which belong to a block that
   * leads a plain receipt page. Inside the booking-details card the card already draws the rule
   * above, and the lead-in read as an empty band. Defaults false so every other caller is
   * unaffected -- see CollapsableBlock's own `section`.
   */
  section?: boolean;
}

export const ReceiptAdditionalInformation = ({
  formResponses,
  section = false,
}: ReceiptAdditionalInformationProps): JSX.Element => {
  const intl = useIntl();

  return (
    <CollapsableBlock title={intl.formatMessage({ id: 'additional_information' })} section={section}>
      {formResponses?.map(response => (
        <ReceiptUserResponse key={response.question} response={response} />
      ))}
    </CollapsableBlock>
  );
};
